import { BdsTypo } from 'blip-ds/dist/blip-ds-react';
import React, { useContext } from 'react';
import DailyEngagedUsersContext from '../../../contexts/DailyEngagedUsersContext';
import { CompiledDailyEngagedUsersTotalConsumedPaperContent } from '../styles';

const CompiledDailyEngagedUserTotalContentComponent: React.FC = () => {
  const { content, compiledDailyEngagedUserDataState } = useContext(DailyEngagedUsersContext);

  const total = (toLocaleString: boolean) => {
    if (compiledDailyEngagedUserDataState.compiledContainsDataOnSelectedMonth) {
      return toLocaleString
        ? compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.total.toLocaleString(content.locale)
        : compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.total;
    } else {
      return '--';
    }
  };

  return (
    <CompiledDailyEngagedUsersTotalConsumedPaperContent>
      <BdsTypo tag="h4" variant="fs-16" bold="bold" margin={true}>
        {content.compiledDailyEngagedUserInformation.totalUsed}
      </BdsTypo>
      <BdsTypo className='totalUsed' tag="h4" variant="fs-32" bold="bold" margin={true} data-total={total(false)}>
        {total(true)}
      </BdsTypo>
    </CompiledDailyEngagedUsersTotalConsumedPaperContent>
  );
};

export default CompiledDailyEngagedUserTotalContentComponent;
